import React from "react";
import { Box, Typography } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";

const EventDateView = ({ event }) => {
  const { timezone, startsAt } = event || {};
  const datePattern = "MMM do";
  const timePattern = "hh:mm a";
  let dateText = "";
  let timeText = "";

  if (startsAt && timezone) {
    try {
      dateText = formatInTimeZone(startsAt.toDate(), timezone, datePattern);
      timeText = formatInTimeZone(startsAt.toDate(), timezone, timePattern);
    } catch (error) {
      dateText = "";
      timeText = "";
    }
  }

  return (
    <Box>
      <Typography>{dateText}</Typography>
      <Typography>{timeText}</Typography>
    </Box>
  );
};

export default EventDateView;
